(function() {
    "use strict";

    angular.module("app").component("habilActivityView", {
        templateUrl: '@/fvm/activity/ActivityView.html',
        bindings: {
            firmInfo: '<'
        },
        controller: ActivityViewController
    });


    ActivityViewController.$inject = ["$rootScope", "$scope"];
    function ActivityViewController($rootScope, $scope) {
        $scope.codeNationalities = $rootScope.codeNationalities;
    }
})();